// @ts-nocheck

export type OwnerGetWithOperationRules = typeof OwnerGetWithOperationRules[keyof typeof OwnerGetWithOperationRules];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerGetWithOperationRules = {
  true: 'true',
  false: 'false',
} as const;
